import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Card, Form, Icon, Image, Input, Message, Divider } from 'semantic-ui-react'
import { sendVerificationEmail, logout } from '../../actions/actionCreators'
import Logo from '../../images/logo-admin.png'
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { NotificationManager } from 'react-notifications';

class VerifyEmail extends React.Component {

  state = {
    email: ""
  };

  logout = (event) => {
    event.preventDefault()
    window.dataLayer.push({
      event: 'user_event',
      eventProps: {
        category: 'user_action',
        action: 'logout',
        label: 'User Logout',
        value: 'true'
    }
    });
    this.props.dispatch(logout( ))
  }

  sendNewVerification = (event) => {
    event.preventDefault()
    this.props.dispatch(sendVerificationEmail( {email: this.state.email} )).then( () => {
      const message = this.props.verifyEmail && this.props.verifyEmail.message ? Translate(this.context, this.props.verifyEmail.message) : ''
      window.dataLayer.push({
        event: 'user_event',
        eventProps: {
          category: 'user_action',
          action: 'verification_email_sent',
          label: 'User Verification Email Sent',
          value: 'true'
        }
      });
      if (message) {
        NotificationManager.success(message);
      }
    })      
  }

  componentDidMount() {
    if(this.props.auth.isLogged) this.setState({email: this.props.auth.user})
  }

  render() {
    if (this.props.auth.isLogged)       
      this.state.email = this.props.auth.user.email
    return (
      <div className="lisia-dialog lisia-centered-dialog">
            <Row center="xs">
              <Col className='email-confirm-dialog-wrapper' xs={11} sm={6} md={4}>
                <Card fluid={true} raised={true} centered={true}>
                  <Card.Content>
                    <div className="loginForm">
                      <Image size='small' src={ Logo } className='m-b-10'/>
                      <Form >
                        <h3 className='text-center'><Text tid='verify_email_title' /></h3>         
                        <Divider />
                        <Form.Field>
                          <label><Text tid="verify_email_description" /></label>
                          <Input type="email" disabled="true" value={this.props.auth.user.email} name="email" onChange={this.handleEmailChange} placeholder={Translate(this.context,'email')} />                         
                        </Form.Field>                             
                        <Divider /> 
                        <div className='footer'>
                          <Link onClick={this.logout.bind(this)} style={{float: 'left'}}>
                            <Text tid="back_to_login" />
                          </Link>
                          <Link onClick={this.sendNewVerification.bind(this)} style={{float: 'right'}}>
                            <Text tid="no_email_received" />
                          </Link>                 
                        </div>               
                      </Form>
                    </div>
                  </Card.Content>
                </Card>
              </Col>
            </Row>          
      </div>
    )
  }
}

VerifyEmail.contextType = LanguageContext;

VerifyEmail.propTypes = {

}

const mapStateToProps = (state) => ({
  auth: state.auth,
  verifyEmail: state.verifyEmail
})

export default connect(mapStateToProps)(VerifyEmail)
